import React, { useState, useEffect } from 'react';
import { Music, Users } from 'lucide-react';
import ArtistCard from '../components/features/ArtistCard';
import { artistsService } from '../services/api-service';
import './Artists.css';

const Artists = () => {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadArtists();
  }, []);

  const loadArtists = async () => {
    try {
      setLoading(true);
      const data = await artistsService.getAllArtists();
      setArtists(data);
    } catch (error) {
      console.error('Error loading artists:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="artists-page">
      {/* Header */}
      <section className="artists-header">
        <div className="container">
          <div className="artists-header-content">
            <Music size={48} className="artists-header-icon" />
            <h1>Our Artists</h1>
            <p>
              Meet the talented artists bringing music, energy, and connection to our 
              celebrations. Each artist brings their unique sound and vibe to create 
              unforgettable experiences.
            </p>
          </div>
        </div>
      </section>

      {/* Artists Grid */}
      <section className="artists-grid-section section">
        <div className="container">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px' }}>
              <p>Loading artists...</p>
            </div>
          ) : artists.length > 0 ? (
            <>
              <div className="artists-count">
                <Users size={20} />
                <span>{artists.length} Artists</span>
              </div>
              <div className="artists-grid">
                {artists.map((artist) => (
                  <ArtistCard 
                    key={artist.id} 
                    artist={artist} 
                    showMusic={true} 
                  />
                ))}
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '60px' }}>
              <p>No artists found. Check back soon!</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="artists-cta section bg-black text-white">
        <div className="container">
          <div className="artists-cta-content">
            <h2>Want to Perform?</h2>
            <p>
              We're always looking for talented artists who align with our values of 
              community, respect, and authentic connection. Get in touch to join our lineup.
            </p>
            <a href="/contact" className="btn btn-white">
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Artists;


